// extracted by mini-css-extract-plugin
export default {"wrapper":"Tag_wrapper__8E5GG","wrapperWithIcon":"Tag_wrapperWithIcon__Cf4lw"};